//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import ContactUsForm from '~/components/form/contact-us-form'
import pageMeta, { mxGetMeta } from '~/mixins/pageMeta'
import { asyncDataCatch, asyncDataStart } from '~/utils/asyncData'
import phones from '~/mixins/phones'
import flags from '~/mixins/flags'

export default {
  name: 'Contact',
  components: { ContactUsForm },
  mixins: [pageMeta, phones, flags],
  async asyncData (ctx) {
    await asyncDataStart(ctx)

    try {
      await mxGetMeta(ctx, {
        meta: {
          method: 'static'
        }
      })
    } catch (e) {
      return asyncDataCatch(ctx, e)
    }
  },
  computed: {
    ...mapState({
      phoneNumbers: state => state.contact.phoneNumbers
    }),
    getContactInfo () {
      return this.$store.getters['contact/getContactInfo'](this.$store.getters['lang/locale'])
    }
  }
}
